import domtoimage from "dom-to-image";
import * as z from "../../../../framework";
import { Widget } from "./widget";

// tslint:disable-next-line:variable-name
export var W_Gauge = function (widgetInstance?) {
    var me = this;
    widgetInstance = widgetInstance || {};

    var parent = widgetInstance.Widget;
    if (parent) {
        me.title = parent.WidgetName;

        var optionsString = parent.Options || "";
        var options = me.parse(optionsString) || {};

        me.intervalInSeconds = options.intervalInSeconds || 60;
        me.pointerDefinitions = options.data || [];
        me.label = options.label || undefined;

        me.scale = {};
        me.scale.minorUnit = options.minorUnit || 5;
        me.scale.majorUnit = options.majorUnit || 50;
        me.scale.startAngle = options.startAngle == undefined
            ? -30
            : options.startAngle;
        me.scale.endAngle = options.endAngle || 210;
        me.scale.min = options.min || 0;
        me.scale.max = options.max || 100;
        me.scale.ranges = options.ranges || [];
        me.scale.majorTicks = options.majorTicks || {};
        me.scale.minorTicks = options.minorTicks || {};
        me.scale.labels = options.labels || {};
        me.scale.rangePlaceholderColor = "#ffffff";
    }

    var widget = new Widget(widgetInstance);
    $.extend(this, widget);

    this.init();
};

W_Gauge.prototype = {
    init: function () {
        var me = this,
            contents = me.contents,
            widget = $(me.contents).closest(".z-widget");

        contents.append("<div class=\"gauge\"></div>");

        me.retrieveDataValue().done(function () {
            contents.find(".gauge").kendoRadialGauge({
                pointer : me.generatePointerArray(),
                scale: me.scale
            });

            var printIcon = widget.find(".print-widget-icon");
            printIcon.removeClass("disabled");
            printIcon.off().tie("click", function () {
                var node = document.getElementById(`${me.id}_WidgetContainer`);
                domtoimage.toPng(node).then(function (dataUrl) {
                    kendo.saveAs({
                        dataURI: dataUrl,
                        fileName: `${me.title} Export.png`
                    });
                });
            });

            if (me.label) {
                contents.find(".gauge").append(`<label class=\"gauge-label\">${me.label}</label>`);
            }
        });
    },
    parse: function (input) {
        try {
            return JSON.parse(input);
        } catch (e) {
            if (window.z.debuggerAttached) {
                console.log(e.message);
            }

            return null;
        }
    },
    createPointers: function (arrayOfPointers, pointerDefinition) {
        var defaultColor = "#428BCA",
            defaultSize = 0.1;

        $.each(pointerDefinition.results, function (index, result) {
            arrayOfPointers.push({
                value: result,
                color: pointerDefinition.color || defaultColor,
                cap: {
                    size: pointerDefinition.size || defaultSize
                }
            });
        });
    },
    generatePointerArray: function () {
        var me = this,
            arrayOfPointers = [];

        $.each(me.pointerDefinitions, function (index, pointerDefinition) {
            me.createPointers(arrayOfPointers, pointerDefinition);
        });

        return arrayOfPointers;
    },
    retrieveDataValue: function () {
        var me = this,
            promises = [];

        $.each(me.pointerDefinitions, function (index, pointerDefinition) {
            var promise = z.ajax({
                url: pointerDefinition.url
            }).done(function (response) {
                var results = response.d.results;
                if (!results) {
                    return;
                }

                pointerDefinition.results = [];

                $.each(results, function (resultIndex, result) {
                    pointerDefinition.results.push(result[pointerDefinition.responseMap]);
                });
            });

            promises.push(promise);
        });

        return $.when.apply(null, promises);
    }
};
